import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import { get, post, userAction } from '@/util/helpers/ajax-helpers';
import DashboardRef from '../../util/DashboardRef';
import css from '../../css/module/insights.css';
import flex from '../../css/module/flex.css';
import cssNW from '../../css/module/new-world.css';
import AjaxSpinner from '../AjaxSpinner';

class GenerateDashboards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinning: null, // index of dashboard template being generated or null
      dashboardsToGenerate: [], // list of DashboardRef objs
    };
    this.generateDashboard = this.generateDashboard.bind(this);
    this.loadTemplateDashboards = this.loadTemplateDashboards.bind(this);
  }

  componentDidMount() {
    this.loadTemplateDashboards();
  }

  loadTemplateDashboards() {
    get('loading template dashboards', '/dashboards/templates').then((json) => {
      this.setState({
        dashboardsToGenerate: json.map((obj) => DashboardRef.build(obj)),
      });
    });
  }

  generateDashboard(dashRef, index) {
    const { onGenerated } = this.props;

    userAction('use-generate-template-dashboard');

    this.setState({
      spinning: index, // disable button while generating
    });
    post('generating dashboard', `/dashboards/templates/${dashRef.id()}`).then(
      (json) => {
        const dashboardRef = DashboardRef.build(json);
        onGenerated(dashboardRef); // open dashboard
      },
    );
  }

  displayDashboards() {
    return this.state.dashboardsToGenerate.map((dash, i) => {
      return (
        <div className={css.insight} href="#" key={dash.id()}>
          <div
            className={`full-width ${flex.row} ${flex.justifyContentBetween} ${flex.alignItemsCenter}`}
          >
            <div className={flex.column}>
              <h5 className="">{dash.name()}</h5>
            </div>
            <div className={flex.alignItemsCenter}>
              {i === this.state.spinning ? (
                <div
                  className={flex.justifyContentCenter}
                  style={{ width: '160px' }}
                >
                  <AjaxSpinner small />
                </div>
              ) : (
                <Button
                  size="large"
                  onClick={() => this.generateDashboard(dash, i)}
                  className={cssNW.notification}
                  disabled={!!this.state.spinning}
                >
                  <b>Generate dashboard</b>
                </Button>
              )}
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const count = this.state.dashboardsToGenerate.length;

    if (count === 0) {
      return null;
    }

    return (
      <div className={css.templateDashboards}>
        <h3>
          <b>
            You have {count} ready-made template{count > 1 ? 's' : ''}
          </b>
        </h3>
        <div
          className={`${css.insightsContainer} ${css.templateDashboardsContainer}`}
        >
          {this.displayDashboards()}
        </div>
      </div>
    );
  }
}

export default GenerateDashboards;
